import { create } from 'zustand'

export const useOrderStore = create((set) => ({
    order: "pop",
    updateOrder: (newOrder) => set(() => ({ order: newOrder })),
}))
